import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { warningActions } from "../store/warningSlice";

const container = document.querySelector("#root");

const WarningDialog = () => {
  const dispatch = useDispatch();

  const { showWarning, message, title } = useSelector((state) => state.warning);

  const closeHandler = () => {
    dispatch(warningActions.removeWarning());
  };

  if (!showWarning) return null;

  return createPortal(
    <>
      {/* Backdrop */}
      <div className="drawer-overlay" onClick={closeHandler} />

      {/* Modal card */}
      <div
        className="card"
        style={{
          position: "fixed",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 25,
          padding: 0,
          width: "90vw",
          maxWidth: "360px",
          display: "flex",
          flexDirection: "column",
          padding: "0.5rem"
        }}
      >
        {/* Header */}  
        <div className="card-header">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                width: 18,
                height: 18,
                stroke: "#c62828",
                fill: "none",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                flexShrink: 0,
              }}
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span className="card-title">{title}</span>
          </div>

          <button className="icon-btn" onClick={closeHandler} aria-label="Close">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "16px 20px" }}>
          <p style={{ fontSize: "13px", color: "var(--bodygray)", lineHeight: 1.6 }}>
            {message}
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "12px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button className="action-btn" onClick={closeHandler}>
            OK
          </button>
        </div>
      </div>
    </>,
    container
  );
};

export default WarningDialog;